class Products {
  constructor(appAPI, appRequestsStorage) {
    'inject';

    this._appAPI = appAPI;
    this._appRequestsStorage = appRequestsStorage;
  }
  getProductsList() {
    return this._appRequestsStorage.save(
      'products.list',
      () => this._appAPI.getProductsList().then(({ products }) => products),
    );
  }
}

export { Products };
